/**
 * The visitor limit's refusal, read off a response.
 *
 * `api/_visitorLimits.js` answers a caller who has used up an AI allowance with a 429 whose body is
 * `{ error: 'rate_limited', message, retryAfter }`. `error` is a CODE for programs; `message` is the
 * sentence written for the person ("Sign in to keep asking, or try again in about 20 minutes"). Most
 * callers in this app show `body.error` as their failure text, so without this every one of them
 * would print the literal "rate_limited" — or, where the text is run through `classifyAiError`, call
 * it the AI provider's rate limit, which it is not.
 *
 * Pure, so the server module can share the code constant and a test can hold both ends of the wire.
 */

export const RATE_LIMITED = 'rate_limited';

/**
 * @param {number} status   the HTTP status
 * @param {object} body     the parsed JSON body, or anything
 * @returns {string|null}   the sentence to show, or null when this is not a limit refusal
 */
export function rateLimitMessage(status, body) {
  if (status !== 429 || body?.error !== RATE_LIMITED) return null;
  return typeof body.message === 'string' && body.message.trim()
    ? body.message
    : 'You have reached the limit for AI requests for now. Try again in a few minutes.';
}
